import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import Settings from '../pages/Pages/Settings';
import FileManager from '../pages/Pages/FileManager';
import DataTables from '../pages/Pages/DataTables';
import PricingTables from '../pages/Pages/PricingTables';
import ErrorPage from '../pages/Pages/ErrorPage';
import Faq from '../pages/Pages/Faq';
import Teams from '../pages/Pages/Teams';
import TermsConditions from '../pages/Pages/TermsConditions';
import MailSuccess from '../pages/Pages/MailSuccess';
import Invoice from '../pages/Invoice';
import ProtectedRouteV2 from './ProtectedRouteV2';

const pagesRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/pages/settings"
      element={
        <>
          <PageTitle title="Settings | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <Settings />
        </>
      }
    />
    <Route
      path="/pages/file-manager"
      element={
        <>
          <PageTitle title="File Manager | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <FileManager />
        </>
      }
    />
    <Route
      path="/pages/data-tables"
      element={
        <>
          <PageTitle title="Data Tables | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <DataTables />
        </>
      }
    />
    <Route
      path="/pages/pricing-tables"
      element={
        <>
          <PageTitle title="Pricing Tables | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <PricingTables />
        </>
      }
    />
    <Route
      path="/pages/error-page"
      element={
        <>
          <PageTitle title="Error Page | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <ErrorPage />
        </>
      }
    />
    <Route
      path="/pages/faq"
      element={
        <>
          <PageTitle title="Faq's | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <Faq />
        </>
      }
    />
    <Route
      path="/pages/team"
      element={
        <>
          <PageTitle title="Teams | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <Teams />
        </>
      }
    />
    <Route
      path="/pages/terms-conditions"
      element={
        <>
          <PageTitle title="Terms & Conditions | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <TermsConditions />
        </>
      }
    />
    <Route
      path="/pages/mail-success"
      element={
        <>
          <PageTitle title="Mail Success | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <MailSuccess />
        </>
      }
    />
    <Route
      path="/invoice"
      element={
        <>
          <PageTitle title="Invoice | TailAdmin" />
          <Invoice />
        </>
      }
    />
  </Route>
);

export default pagesRoutes;
